export const THIRD_PARTY_RECOMMENDATIONS = [
  {
    name: 'Able CDP',
    key: 'able_cdp',
    href: 'https://calendly.com/integration/able-cdp',
  },
  {
    name: 'ActiveCampaign',
    key: 'activecampaign',
    href: 'https://calendly.com/integration/activecampaign',
  },
  {
    name: 'Airtable',
    key: 'airtable',
    href: 'https://zapier.com/apps/calendly/integrations/airtable',
  },
  {
    name: 'ApiX-Drive',
    key: 'apix-drive',
    href: 'https://calendly.com/integration/apix-drive',
  },
  {
    name: 'Aritic',
    key: 'aritic',
    href: 'https://docs.aritic.com/aritic-pinpoint/kb/calendly-integration/',
  },
  {
    name: 'Asana',
    key: 'asana',
    href: 'https://zapier.com/apps/calendly/integrations/asana',
  },
  {
    name: 'Autoklose',
    key: 'autoklose',
    href: 'https://calendly.com/blog/autoklose-calendly-integration-sales-automation',
  },
  {
    name: 'AWeber',
    key: 'aweber',
    href: 'https://calendly.com/integration/aweber',
  },
  {
    name: 'Callendar',
    key: 'callendar',
    href: 'https://calendly.com/integration/callendar',
  },
  {
    name: 'CallHippo',
    key: 'callhippo',
    href: 'https://callhippo.com/calendly-integration/',
  },
  {
    name: 'Chameleon',
    key: 'chameleon',
    href: 'https://www.trychameleon.com/integrations/calendly',
  },
  {
    name: 'Chatbase',
    key: 'chatbase',
    href: 'https://calendly.com/integration/chatbase',
  },
  {
    name: 'Clearbit',
    key: 'clearbit',
    href: 'https://calendly.com/integration/clearbit',
  },
  {
    name: 'ClickSend SMS',
    key: 'clicksend_sms',
    href: 'https://zapier.com/apps/calendly/integrations/clicksend',
  },
  {
    name: 'ClickUp',
    key: 'clickup',
    href: 'https://clickup.com/integrations/calendly',
  },
  {
    name: 'Close',
    key: 'close',
    href: 'https://calendly.com/integration/close',
  },
  {
    name: 'CloudEagle',
    key: 'cloudeagle',
    href: 'https://calendly.com/integration/cloudeagle',
  },
  {
    name: 'Constant Contact',
    key: 'constant_contact',
    href: 'https://zapier.com/apps/calendly/integrations/constant-contact',
  },
  {
    name: 'ConvertKit',
    key: 'convertkit',
    href: 'https://zapier.com/apps/calendly/integrations/convertkit',
  },
  {
    name: 'Copper',
    key: 'copper',
    href: 'https://zapier.com/apps/calendly/integrations/copper',
  },
  {
    name: 'Coupler.io',
    key: 'coupler.io',
    href: 'https://calendly.com/integration/couplerio',
  },
  {
    name: 'Drip',
    key: 'drip',
    href: 'https://www.drip.com/integrations/calendly',
  },
  {
    name: 'eatNgage',
    key: 'eatngage',
    href: 'https://calendly.com/integration/eatngage',
  },
  {
    name: 'Feathery',
    key: 'feathery',
    href: 'https://www.feathery.io/integrations/calendly',
  },
  {
    name: 'Flexie',
    key: 'flexie',
    href: 'https://flexie.io/cut-the-middleman-calendly-direct-integration/',
  },
  {
    name: 'Formcrafts',
    key: 'formcrafts',
    href: 'https://calendly.com/integration/formcrafts',
  },
  {
    name: 'Freshsales',
    key: 'freshsales',
    href: 'https://zapier.com/apps/calendly/integrations/freshsales',
  },
  {
    name: 'Gem',
    key: 'gem',
    href: 'https://help.gem.com/en/articles/3232736-calendly-gem-integration',
  },
  {
    name: 'Google Sheets',
    key: 'google_sheets',
    href: 'https://zapier.com/apps/calendly/integrations/google-sheets',
  },
  {
    name: 'Grammarly',
    key: 'grammarly',
    href: 'https://calendly.com/integration/grammarly',
  },
  {
    name: 'Greenhouse',
    key: 'greenhouse',
    href: 'https://calendly.com/integration/greenhouse',
  },
  {
    name: 'Groove',
    key: 'groove',
    href: 'https://zapier.com/apps/calendly/integrations/groove',
  },
  {
    name: 'HighLevel',
    key: 'highlevel',
    href: 'https://zapier.com/apps/calendly/integrations/leadconnector',
  },
  {
    name: 'Honeybook',
    key: 'honeybook',
    href: 'https://help.honeybook.com/en/articles/2209053-integrating-with-calendly',
  },
  {
    name: 'IFTTT',
    key: 'ifttt',
    href: 'https://ifttt.com/calendly',
  },
  {
    name: 'Insightly',
    key: 'insightly',
    href: 'https://zapier.com/apps/calendly/integrations/insightly',
  },
  {
    name: 'JazzHR',
    key: 'jazzhr',
    href: 'https://calendly.com/integration/jazzhr',
  },
  {
    name: 'Join.Me',
    key: 'join.me',
    href: 'https://zapier.com/apps/calendly/integrations/joinme',
  },
  {
    name: 'Jotform',
    key: 'jotform',
    href: 'https://calendly.com/integration/jotform',
  },
  {
    name: 'Kajabi',
    key: 'kajabi',
    href: 'https://calendly.com/integration/kajabi',
  },
  {
    name: 'Keap',
    key: 'keap',
    href: 'https://zapier.com/apps/calendly/integrations/keap-max-classic',
  },
  {
    name: 'Keragon',
    key: 'keragon',
    href: 'https://calendly.com/integration/keragon',
  },
  {
    name: 'Kit',
    key: 'kit',
    href: 'https://calendly.com/integration/kit',
  },
  {
    name: 'Klaviyo',
    key: 'klaviyo',
    href: 'https://zapier.com/apps/calendly/integrations/klaviyo',
  },
  {
    name: 'Kommo',
    key: 'kommo',
    href: 'https://calendly.com/integration/kommo',
  },
  {
    name: 'Leadpages',
    key: 'leadpages',
    href: 'https://calendly.com/blog/leadpages-landing-page-scheduling-embed',
  },
  {
    name: 'LegalMate',
    key: 'legalmate',
    href: 'https://www.legalmate.co/pre-built/calendly-automation',
  },
  {
    name: 'LinkedIn Ads',
    key: 'linkedin_ads',
    href: 'https://calendly.com/integration/linkedin-ads',
  },
  {
    name: 'Linktree',
    key: 'linktree',
    href: 'https://calendly.com/integration/linktree',
  },
  {
    name: 'Livechat',
    key: 'livechat',
    href: 'https://www.livechat.com/updates/integrations/schedule-meetings-with-calendly/',
  },
  {
    name: 'Loom',
    key: 'loom',
    href: 'https://calendly.com/integration/loom',
  },
  {
    name: 'MailerLite',
    key: 'mailerlite',
    href: 'https://zapier.com/apps/calendly/integrations/mailerlite',
  },
  {
    name: 'Make',
    key: 'make',
    href: 'https://calendly.com/integration/make',
  },
  {
    name: 'ManyChat',
    key: 'manychat',
    href: 'https://zapier.com/apps/calendly/integrations/manychat',
  },
  {
    name: 'Monday.com',
    key: 'monday.com',
    href: 'https://zapier.com/apps/calendly/integrations/monday',
  },
  {
    name: 'n8n',
    key: 'n8n',
    href: 'https://n8n.io/integrations/calendly-trigger/',
  },
  {
    name: 'NimbleCRM',
    key: 'nimblecrm',
    href: 'https://zapier.com/apps/calendly/integrations/nimble',
  },
  {
    name: 'Notion',
    key: 'notion',
    href: 'https://www.notion.com/integrations/calendly',
  },
  {
    name: 'Nutshell',
    key: 'nutshell',
    href: 'https://calendly.com/integration/nutshell',
  },
  {
    name: 'Omnisend',
    key: 'omnisend',
    href: 'https://zapier.com/apps/calendly/integrations/omnisend',
  },
  {
    name: 'ON24',
    key: 'on24',
    href: 'https://calendly.com/integration/on24',
  },
  {
    name: 'OneCockpit',
    key: 'onecockpit',
    href: 'https://calendly.com/integration/onecockpit',
  },
  {
    name: 'Ontraport',
    key: 'ontraport',
    href: 'https://zapier.com/apps/calendly/integrations/ontraport',
  },
  {
    name: 'Oracle Eloqua',
    key: 'oracle_eloqua',
    href: 'https://calendly.com/integration/oracle-eloqua',
  },
  {
    name: 'Ortto (formerly Autopilot)',
    key: 'ortto',
    href: 'https://ortto.com/integrations/calendly/',
  },
  {
    name: 'Outfunnel',
    key: 'outfunnel',
    href: 'https://calendly.com/integration/outfunnel',
  },
  {
    name: 'Pendo',
    key: 'pendo',
    href: 'https://calendly.com/integration/pendo',
  },
  {
    name: 'Pipedream',
    key: 'pipedream',
    href: 'https://calendly.com/integration/pipedream',
  },
  {
    name: 'Pipedrive',
    key: 'pipedrive',
    href: 'https://zapier.com/apps/calendly/integrations/pipedrive',
  },
  {
    name: 'Pipeliner',
    key: 'pipeliner',
    href: 'https://www.pipelinersales.com/crm/apps/calendly/',
  },
  {
    name: 'Plusthis',
    key: 'plusthis',
    href: 'https://www.plusthis.com/tools/5-calendly-connection',
  },
  {
    name: 'Podium',
    key: 'podium',
    href: 'https://calendly.com/integration/podium',
  },
  {
    name: 'Postal',
    key: 'postal',
    href: 'https://calendly.com/integration/postal',
  },
  {
    name: 'Pumble',
    key: 'pumble',
    href: 'https://calendly.com/integration/pumble',
  },
  {
    name: 'Questflow',
    key: 'questflow',
    href: 'https://calendly.com/integration/questflow',
  },
  {
    name: 'Quicki (formerly Kommute)',
    key: 'quicki',
    href: 'https://www.quicki.com/integrations/calendly',
  },
  {
    name: 'RD Station',
    key: 'rd_station',
    href: 'https://zapier.com/apps/calendly/integrations/rd-station',
  },
  {
    name: 'Reachdesk',
    key: 'reachdesk',
    href: 'https://calendly.com/integration/reachdesk',
  },
  {
    name: 'Redtail CRM',
    key: 'redtail_crm',
    href: 'https://zapier.com/apps/calendly/integrations/redtailcrm',
  },
  {
    name: 'Relay.app',
    key: 'relay.app',
    href: 'https://www.relay.app/apps/calendly/integrations',
  },
  {
    name: 'Responsly',
    key: 'responsly',
    href: 'https://calendly.com/integration/responsly',
  },
  {
    name: 'RoboRecruiter',
    key: 'roborecruiter',
    href: 'https://calendly.com/integration/roborecruiter',
  },
  {
    name: 'Salesmsg',
    key: 'salesmsg',
    href: 'https://calendly.com/integration/salesmsg',
  },
  {
    name: 'SalesRabbit',
    key: 'salesrabbit',
    href: 'https://salesrabbit.com/integrations/calendly/',
  },
  {
    name: 'Sendoso',
    key: 'sendoso',
    href: 'https://calendly.com/integration/sendoso',
  },
  {
    name: 'Sendspark',
    key: 'sendspark',
    href: 'https://calendly.com/integration/sendspark',
  },
  {
    name: 'Shape',
    key: 'shape',
    href: 'https://zapier.com/apps/calendly/integrations/shape',
  },
  {
    name: 'SharpSpring',
    key: 'sharpspring',
    href: 'https://zapier.com/apps/calendly/integrations/sharpspring',
  },
  {
    name: 'Skyvia',
    key: 'skyvia',
    href: 'https://skyvia.com/connectors/calendly?utm_source=calendly_marketplace&utm_medium=referral&utm_campaign=marketplace',
  },
  {
    name: 'Smith.ai',
    key: 'smith.ai',
    href: 'https://calendly.com/integration/smithai',
  },
  {
    name: 'Spacebring',
    key: 'spacebring',
    href: 'https://calendly.com/integration/spacebring',
  },
  {
    name: 'Stax Payments',
    key: 'stax_payments',
    href: 'https://zapier.com/apps/calendly/integrations/stax',
  },
  {
    name: 'Streak',
    key: 'streak',
    href: 'https://calendly.com/integration/streak',
  },
  {
    name: 'Supademo',
    key: 'supademo',
    href: 'https://calendly.com/integration/supademo',
  },
  {
    name: 'theMarketer',
    key: 'themarketer',
    href: 'https://calendly.com/integration/themarketer',
  },
  {
    name: 'Thoughtly',
    key: 'thoughtly',
    href: 'https://calendly.com/integration/thoughtly',
  },
  {
    name: 'Todoist',
    key: 'todoist',
    href: 'https://zapier.com/apps/calendly/integrations/todoist',
  },
  {
    name: 'Tray.io',
    key: 'tray.io',
    href: 'https://tray.io/connectors/calendly-integrations',
  },
  {
    name: 'Trello',
    key: 'trello',
    href: 'https://zapier.com/apps/calendly/integrations/trello',
  },
  {
    name: 'Twilio',
    key: 'twilio',
    href: 'https://zapier.com/apps/calendly/integrations/twilio',
  },
  {
    name: 'Typeform',
    key: 'typeform',
    href: 'https://calendly.com/integration/typeform',
  },
  {
    name: 'Unbounce',
    key: 'unbounce',
    href: 'https://calendly.com/help/how-to-add-calendly-to-an-unbounce-site',
  },
  {
    name: 'viaSocket',
    key: 'viasocket',
    href: 'https://calendly.com/integration/viasocket',
  },
  {
    name: 'VideoAsk',
    key: 'videoask',
    href: 'https://calendly.com/integration/videoask',
  },
  {
    name: 'Webflow',
    key: 'webflow',
    href: 'https://help.webflow.com/hc/en-us/articles/33961310172435-Add-a-calendar-to-your-site-with-Calendly',
  },
  {
    name: 'Wistia',
    key: 'wistia',
    href: 'https://wistia.com/learn/product-updates/introducing-new-call-to-action-options-in-soapbox',
  },
  {
    name: 'Workato',
    key: 'workato',
    href: 'https://calendly.com/integration/workato',
  },
  {
    name: 'Zoho',
    key: 'zoho',
    href: 'https://zapier.com/apps/calendly/integrations/zoho-crm',
  },
  {
    name: 'Zoho Flow',
    key: 'zoho_flow',
    href: 'https://help.zoho.com/portal/en/kb/flow/user-guide/app-specific-documentation/articles/calendly',
  },
  {
    name: 'Zoho Recruit',
    key: 'zoho_recruit',
    href: 'https://calendly.com/integration/zoho-recruit',
  },
  {
    name: 'ZoomInfo',
    key: 'zoominfo',
    href: 'https://calendly.com/integration/zoominfo',
  },
]
